import React, { useEffect, useState, useContext } from "react";
import Utils from "../../Utils";
import UserContext from "../../contexts/UserContext";
import { Loader } from "..";

const ExperienceBlock = (props) => {
  const { getServerData, getUserData } = useContext(UserContext);
  const slug = Utils.hasSubdomain() ? Utils.subdomain() : getUserData().slug;
  const [tData, setTData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = () => {
    getServerData(`trainer/blocks/${slug}?mode[]=experiences`, true)
      .then((tData) => {
        setTData(tData);
        setLoading(false);
      })
      .catch((msg) => {
        setTData({ success: false, message: msg });
        setLoading(false);
      });
  };

  useEffect(fetchData, []);

  return (
    <>
      {loading && <Loader />}
      {!loading && (
        <div className="profileContent tab-pane mt-4 mb-4" id="experienceContent">
          <div className="">
            <div className="">
              <div className="">
                {tData.experiences.map((a) => (
                  <div className="AboutawadText">
                    <span className="AboutawardYear">{a.company}</span> <span>{a.location}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ExperienceBlock;
